import { useState, useMemo, useEffect, useRef } from 'react';
import { BsChevronLeft, BsChevronRight, BsChevronDoubleDown } from 'react-icons/bs';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import styles from './ImageNav.module.scss';
import { PRODUCTS } from './constants';

const cx = classNames.bind(styles);

const ImageNav = ({ data }) => {
  const observeRef = useRef();
  const [showNextArrow, setShowNextArrow] = useState(true);

  const { prevProduct, nextProduct } = useMemo(() => {
    const currentIndex = PRODUCTS.findIndex((product) => product.title === data.title);
    const prevIndex = currentIndex === 0 ? PRODUCTS.length - 1 : currentIndex - 1;
    const nextIndex = currentIndex === PRODUCTS.length - 1 ? 0 : currentIndex + 1;

    return {
      prevProduct: PRODUCTS[prevIndex],
      nextProduct: PRODUCTS[nextIndex],
    };
  }, [data]);

  useEffect(() => {
    if (observeRef.current) {
      const observer = new IntersectionObserver(
        (entry) => {
          setShowNextArrow(!entry[0].isIntersecting);
        },
        { threshold: 0.2 },
      );
      observer.observe(observeRef.current);
    }
  }, []);

  return (
    <div className={cx(['container', data.title])}>
      <div className={cx('imageWrapper')}>
        <Link to={prevProduct.uri} className={cx('arrow')}>
          <BsChevronLeft size={50} />
          {prevProduct.title}
        </Link>
        <img src={data.closeImage} alt={data.name} />
        <Link to={nextProduct.uri} className={cx('arrow')}>
          {nextProduct.title}
          <BsChevronRight size={50} />
        </Link>
      </div>
      <div className={cx('imageWrapper')}>
        <img src={data.openImage} alt={data.name} />
      </div>
      {showNextArrow && (
        <div className={cx('next')}>
          <BsChevronDoubleDown size={50} />
        </div>
      )}
      <div ref={observeRef} />
    </div>
  );
};

export default ImageNav;
